import httpClient from '@/core/http/client.service';

const getCustomFormulationList = () => httpClient.get('/api/v1/tpn/customFormulationList?_format=json&method=getList&type=list').then((res) => res);
const getFormulationsStats = () => httpClient.get('/api/v1/tpn/customFormulationList?_format=json&method=getStats').then((res) => res);
const getCustomFormulationRecent = (query) => httpClient.get('/api/v1/tpn/customFormulationList?_format=json&method=getList&type=recent&query=' + query).then((res) => res);
const getCustomFormulationInfo = (id) => httpClient.get('/api/v1/tpn/customFormulation?_format=json&id=' + id).then((res) => res);
const handleCustomFormulation = (data) => httpClient.post('/api/v1/tpn/customFormulationRecord?_format=json', data);
const getCustomFormulationRequest = () => httpClient.get('/api/v1/tpn/customFormulationRequest?_format=json').then((res) => res);
const createCustomFormulationRequest = (data) => httpClient.post('/api/v1/tpn/customFormulationRequest?_format=json', data);
const deleteCustomFormulation = (data) => httpClient.delete('/api/v1/tpn/customFormulationRecord/' + data + '?_format=json');

export default {
  getCustomFormulationList,
  getFormulationsStats,
  getCustomFormulationRecent,
  getCustomFormulationInfo,
  handleCustomFormulation,
  getCustomFormulationRequest,
  createCustomFormulationRequest,
  deleteCustomFormulation,
};
